<template>
  <div class="enterprise-news-root">
    <div v-show="!showDetail" ref="SCROLL_ROOT" class="root-scrollbar">
      <div class="content-layout">
        <div class="content-top">
          <span class="title">光阳蛋业新闻</span>
          <div>
            <span class="current-count">{{ +position + 1 }}</span>
            <span class="total-count">/{{ total }}</span>
          </div>
        </div>

        <div class="carousel-news-layout">
          <div ref="CAROUSEL_ROOT" class="carousel-content">
            <div class="carousel">
              <div
                v-for="(item, index) in topList"
                :key="index"
                :ref="`ITEM${index}`"
                class="carousel-content-item"
                @click="onNewsItemClick(item.id)"
              >
                <div class="new-item">
                  <img
                    class="new-item__image"
                    :src="item.contentFileList && item.contentFileList.length > 0 ? item.contentFileList[0] : ''"
                    alt=""
                  />
                  <div class="new-item__content">
                    <div class="content-time">
                      <div class="time1">
                        {{ item.year }}
                      </div>
                      <div class="time2">
                        {{ item.monthDay }}
                      </div>
                    </div>
                    <div class="title">{{ item.contentTitle }}</div>
                    <p class="sub">
                      {{ item.contentShortTitle }}
                    </p>

                    <!-- <div class="website-logo-root">
                      <img v-for="(it, id) in websiteLogoList" :key="id" style="margin: 0 10px" :src="it" alt="" />
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="carousel-control-layout">
            <el-input
              v-model="searchTitle"
              class="news-search"
              clearable
              prefix-icon="el-icon-search"
              :placeholder="$t('searchReport')"
              @input="handleSearchInput"
              @clear="handleSearch"
              @keyup.enter.native="handleSearch"
            />
            <div class="control-btns">
              <img src="@images/icon/en_arrow_left.png" alt="" @click="onCarouselTo(0)" />
              <img src="@images/icon/en_arrow_right.png" alt="" @click="onCarouselTo(1)" />
            </div>
          </div>
        </div>

        <div ref="NEWS_LIST_TOP" class="line-h"></div>

        <div v-loading="loading" style="padding-bottom: 20px">
          <div
            v-for="(item, index) in respData"
            :key="index"
            class="new-item2"
            style="cursor: pointer"
            @click="onNewsItemClick(item.id)"
          >
            <!-- <img class="new-item__image" src="@images/img_new1.png" alt="" /> -->
            <img
              class="new-item2__image"
              :src="
                item.contentFileList && item.contentFileList.length > 0
                  ? item.contentFileList[0]
                  : require('@images/bg/newsItemBg.png')
              "
            />
            <div class="new-item2__content2">
              <div class="content-time">
                <div class="time1">
                  {{ item.year }}
                </div>
                <div class="time2">
                  {{ item.monthDay }}
                </div>
              </div>
              <span class="title2">{{ item.contentTitle }}</span>
              <p class="sub2">
                {{ item.contentShortTitle }}
              </p>

              <!-- <div class="website-logo-root">
                <img v-for="(it, id) in websiteLogoList" :key="id" style="margin: 0 10px" :src="it" alt="" />
              </div> -->
            </div>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            :page-size="pageSize"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="newsTotal"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <news-detail v-if="showDetail" ref="NEWS_DETAIL" class="news-detail-root" @onBack="onBack" />
  </div>
</template>

<script>
import { Input } from 'element-ui'
import { fetchNewList, fetcTopNewList } from './model'
import NewsDetail from '@views/components/news-detail'
export default {
  components: {
    NewsDetail,
    'el-input': Input
  },
  // directives: {
  //   Loading: Loading.directive
  // },
  data() {
    return {
      status: false,
      showDetail: false,
      position: 0,
      total: 0,
      page: 1,
      pageSize: 8,
      newsTotal: 0,
      respData: [],
      topList: [],
      searchTitle: '',
      searchTimer: null,
      listRequestId: 0,
      websiteLogoList: [
        require('@images/icon/en_website_logo_rmw.png'),
        require('@images/icon/en_website_logo_xhw.png'),
        require('@images/icon/en_website_logo_yc.png'),
        require('@images/icon/en_website_logo_ysw.png')
      ],
      loading: false,
      language: localStorage.getItem('Language')
    }
  },
  mounted() {
    this.getData()
    if (this.$route.query.newsId) {
      this.onNewsItemClick(this.$route.query.newsId)
    }
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer)
  },
  methods: {
    handleSearchInput() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(this.handleSearch, 400)
    },
    handleSearch() {
      clearTimeout(this.searchTimer)
      this.page = 1
      this.getNewList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getNewList()
      this.$nextTick(this.scrollToNewsList)
    },
    scrollToNewsList() {
      const scrollRoot = this.$refs.SCROLL_ROOT
      const listTop = this.$refs.NEWS_LIST_TOP
      if (!scrollRoot || !listTop) return

      const scrollRootTop = scrollRoot.getBoundingClientRect().top
      const listTopPosition = listTop.getBoundingClientRect().top
      scrollRoot.scrollTop += listTopPosition - scrollRootTop
    },
    async getNewList() {
      const requestId = ++this.listRequestId
      this.loading = true
      try {
        const resp = await fetchNewList({
          categoryId: '1985184303233454081',
          page: this.page,
          limit: this.pageSize,
          orderField: 'contentDate',
          order: 'desc',
          publishChannel: '0,1',
          contentTitle: this.searchTitle.trim(),
          contentType: this.language === 'zh-CN' ? '0,1' : '0,2'
        })
        if (requestId !== this.listRequestId) return
        // console.log(resp1, resp)
        if (resp.code === 0 && resp.data && resp.data.list) {
          const list = resp.data.list
          list.forEach((item) => {
            if (item.contentDate && item.contentDate.length >= 10) {
              // 提取年份 (前4位)
              item.year = item.contentDate.substring(0, 4)
              // 提取月日 (第6-10位)
              item.monthDay = item.contentDate.substring(5, 10)
            }
          })
          this.respData = list
          this.newsTotal = resp.data.total
        }
      } catch (error) {
        console.error('数据加载失败:', error)
      } finally {
        // 关闭loading
        if (requestId === this.listRequestId) {
          this.loading = false
        }
      }
    },
    async getData() {
      this.getNewList()
      const resp1 = await fetcTopNewList({
        categoryId: '1985184303233454081',
        page: 1,
        limit: 100,
        publishChannel: '0,1',
        contentType: this.language === 'zh-CN' ? '0,1' : '0,2'
      })
      if (resp1.code === 0 && resp1.data && resp1.data.list) {
        const topList = resp1.data.list
        topList.forEach((item) => {
          if (item.contentDate && item.contentDate.length >= 10) {
            // 提取年份 (前4位)
            item.year = item.contentDate.substring(0, 4)
            // 提取月日 (第6-10位)
            item.monthDay = item.contentDate.substring(5, 10)
          }
        })
        this.topList = topList
        this.total = resp1.data.total
      }
    },
    onNewsItemClick(id) {
      this.showDetail = true
      this.$nextTick(() => {
        this.$refs.NEWS_DETAIL.init(id)
      })
    },
    onBack() {
      this.showDetail = false
      if (this.$route.query.newsId) {
        const query = { ...this.$route.query }
        delete query.newsId
        this.$router.replace({ path: this.$route.path, query })
      }
    },
    onCarouselTo(index) {
      this.status = true
      const length = this.topList.length

      if (index === 0) {
        if (this.position === 0) {
          return
          // this.position = length
        } else {
          this.position--
        }
      } else if (index === 1) {
        if (this.position === length - 1) {
          // this.position = 0
          return
        } else {
          this.position++
        }
      }
      this.setCarousel()
    },
    setCarousel(direction) {
      const eleRoot = this.$refs.CAROUSEL_ROOT
      const width = +window.getComputedStyle(eleRoot).width.replace('px', '')
      for (let index = 0; index < this.topList.length; index++) {
        const ele = this.$refs['ITEM' + index][0]
        ele.style.transition = 'transform 0.5s'
        const num = direction === 0 ? width * this.position : -width * this.position
        ele.style.transform = `translateX(${num}px)`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style';
</style>
